var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Chevron_up") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chevron_up",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3139938_arrow_chevron_down_down-arrow_downward_icon-(1)",
    transform: "translate(20, 20.1003) scale(1, -1) translate(-20, -20.1003)translate(13, 16)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.166132021,3.24468126 L8.03031943,3.14729291 C8.51763442,3.14125811 8.91757346,3.53141279 8.92360826,4.01872779 C8.92369846,4.02601216 8.92369846,4.03329737 8.92360826,4.04058174 L8.92327915,4.06715702 C8.91723171,4.55549335 8.52282904,4.94989602 8.0344927,4.95594347 L0.170305298,5.05333182 C-0.317009699,5.05936662 -0.716948732,4.66921193 -0.722983533,4.18189693 C-0.723073741,4.17461256 -0.723073741,4.16732736 -0.722983533,4.16004299 L-0.72265443,4.13346771 C-0.716606982,3.64513137 -0.322204312,3.2507287 0.166132021,3.24468126 Z",
    id: "Rectangle-1",
    transform: "translate(4.1003, 4.1003) rotate(45) translate(-4.1003, -4.1003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.96968057,3.14729312 L13.833868,3.24468147 C14.3222043,3.25072892 14.716607,3.64513158 14.7226544,4.13346792 L14.7229835,4.1600432 C14.7290183,4.64735819 14.3388636,5.04729723 13.8515486,5.05333203 C13.8442643,5.05342224 13.8369791,5.05342224 13.8296947,5.05333203 L5.9655073,4.95594368 C5.47717096,4.94989623 5.08276829,4.55549356 5.07672085,4.06715723 L5.07639174,4.04058195 C5.07035694,3.55326695 5.46051163,3.15332792 5.94782663,3.14729312 C5.955111,3.14720291 5.9623962,3.14720291 5.96968057,3.14729312 Z",
    id: "Rectangle-1",
    transform: "translate(9.8997, 4.1003) rotate(-45) translate(-9.8997, -4.1003)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/chevron_up.7d3a35ee648324ce1daf2581b840914f.svg";
export { ForwardRef as ReactComponent };